import * as React from 'react';
import { useDispatch } from 'react-redux';
import {
  LeaveContactsModal,
  TLeaveContactsModalOnSubmitParams,
  attemptToGetMessageFromUnknownError,
} from '@cian/frontend-e2e-deal-component';

import { leaveContacts } from '../../actions/leaveContacts';
import { TThunkDispatch } from '../../types/redux';
import { TLeaveContactsSendFromAllowedValues } from '../../types/promoInfo';
import { trackLeaveContactsFormSubmit } from './tracking';

export const LeaveContactsFormModalContainer: React.FC<
  React.PropsWithChildren<{
    open: boolean;
    onClose(): void;
    sentFrom: TLeaveContactsSendFromAllowedValues;
  }>
> = props => {
  const dispatch = useDispatch<TThunkDispatch>();

  const handleFormSubmit = async (params: TLeaveContactsModalOnSubmitParams) => {
    const result = await dispatch(leaveContacts({ ...params, sentFrom: props.sentFrom }));
    const isError = 'error' in result;

    if (!isError) {
      trackLeaveContactsFormSubmit(props.sentFrom);
    }

    return {
      status: /* istanbul ignore next */ isError ? 'error' : 'success',
      errorMessage: attemptToGetMessageFromUnknownError(result.error),
    } as const;
  };

  return (
    <LeaveContactsModal
      isOpen={props.open}
      onClose={props.onClose}
      onSubmit={handleFormSubmit}
      texts={{
        title: 'Оставьте свои контакты',
        subtitle: 'Специалист свяжется с вами и расскажет про процесс и дальнейшие шаги.',
        success: 'Специалист перезвонит вам в ближайшее время',
      }}
    />
  );
};
